var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4074",
    "data-name": "Group 4074",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M13.876,3a4.629,4.629,0,0,1,4.5,4.914c0,5.733-6.143,9.009-8.19,10.238C8.143,16.923,2,13.647,2,7.914A4.648,4.648,0,0,1,6.5,3,5.419,5.419,0,0,1,10.19,4.638,5.419,5.419,0,0,1,13.876,3ZM10.955,15.78a22.075,22.075,0,0,0,1.982-1.393c2.441-1.941,3.805-4.062,3.805-6.473a3,3,0,0,0-2.867-3.276A3.774,3.774,0,0,0,11.348,5.8L10.19,6.954,9.032,5.8A3.774,3.774,0,0,0,6.5,4.638,3.021,3.021,0,0,0,3.638,7.914c0,2.411,1.364,4.532,3.8,6.473a22.038,22.038,0,0,0,1.983,1.392c.245.155.487.3.765.468.278-.165.52-.314.765-.468Z",
    transform: "translate(-0.362 -1.362)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteYellow);
export default __webpack_public_path__ + "static/media/favourite-yellow.8a3f369a286a70c94a1cc2972797e119.svg";
export { ForwardRef as ReactComponent };